// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"TabContainer_tabContainer__2gzvi","tabBar":"TabContainer_tabBar__3QCBe","tabBody":"TabContainer_tabBody__1xVOD"};